import { SelectItem } from 'primereact/selectitem';

const pageSize: SelectItem[] = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 }
];
export default pageSize;
